import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class ShipmentDetailService extends DatabaseGwService {
  URL_PATH: string = "/shipment-details";
}
